import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import cubes from "../../assets/2cubes.png";
import ModalPay from "./ModalPay";
import ModalPago from "./ModalPago";

export default function Evento() {
  const { event } = useSelector((state) => state.coffee);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [pagarModal,isSetPagar] = useState(false)
  const [clickPagar, setClickPagar] = useState(false)

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="w-full sm:min-h-[100vh] bg-cream">
      <ModalPay isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} isSetPagar={isSetPagar} setClickPagar={setClickPagar} />
      <ModalPago pagarModal={pagarModal} isSetPagar={isSetPagar} clickPagar={clickPagar}  />

      <img
        src={cubes}
        className="absolute bottom-4 right-10 xl:w-[300px] 3xl:w-[400px]  hidden md:block"
        alt=""
      />

      <div className="px-4 xl:px-40 3xl:px-72 w-full pt-28 md:pt-28">
        <div className="flex flex-col md:flex-row">
          <div className="w-full md:w-[550px]">
            <img
              className="sm:w-full w-[300px] sm:m-0 m-auto rounded-3xl h-[50vh] md:h-[80vh] border-[3px] border-mandarin"
              src={event.image}
              alt=""
            />
          </div>

          <div className="mt-5 md:mt-0 md:ml-5 w-full md:w-[50%]">
            <h1 className="text-4xl md:text-6xl text-mandarin font-bold sm:ml-0 ml-10 uppercase">
              {event.tipo}
            </h1>
            <p className="mt-3 text-mandarin text-lg sm:ml-0 ml-10 ">
              Fecha: <span className="font-semibold">{event.fecha}</span>
            </p>
            <p className="mt-1 text-mandarin text-lg sm:ml-0 ml-10 ">
              Lugar: <span className="font-semibold">{event.lugar}</span>
            </p>
            <p className="mt-1 text-mandarin text-lg sm:ml-0 ml-10 ">
              Precio: $<span className="font-semibold">{event.price}</span>
            </p>

            <div className="mt-8 text-mandarin">
              <p>Seleccionar ticket:</p>
              <div className="flex justify-between items-center px-5">
                <p className="mt-5 ml-5 font-bold">Entrada General</p>
                <p className="font-bold">${event.price}</p>
              </div>
              <div className="p-2 mt-5">
                <button
                  onClick={() => setIsModalOpen(true)}
                  className="w-full bg-mandarin text-white p-3 text-lg rounded-full transition-colors hover:bg-mandarin2"
                >
                  Comprar ahora
                </button>
              </div>
              <p className="mt-5">
                ¡Lo llevaremos de regreso al Boulevard Venice para un evento
                ÉPICO! ¡Marque sus calendarios para el domingo 16 de febrero
                para baños de hielo, saunas y diversión con nuestras personas
                favoritas! No podemos esperar a ver todas las caras nuevas y
                familiares por igual.
              </p>
              <div className="mt-5">
                <p>Emocionate por:</p>
                <ul>
                  <li>🎟️ Venta de entradas por Sweatpals</li>
                  <li>🧉 Kombucha de JuneShine</li>
                  <li>💪🏻 Bebidas proteicas de Koia</li>
                  <li>💧 Electrolitos por hidratación de ocio</li>
                  <li>🥵 Sauna de Westside Sweat Club</li>
                  <li>☕️ Café por Boulevard</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-44 sm:px-56 px-2 flex flex-col text-mandarin justify-center ">
        <h1 className="sm:text-6xl text-3xl text-center font-bold mb-3">Proximos Eventos</h1>

        <div className="border-t border-t-mandarin sm:flex justify-between p-6  ">
          <p className="sm:text-xl font-semibold">Sabado 25</p>
          <p className="text-lg">10am - 12pm</p>
          <p className="sm:text-lg font-semibold">
          Entradas en vivo el miércoles 3/12 a las 10 a.m.</p>
        </div>

        <div className="border-t border-t-mandarin sm:flex justify-between p-6 ">
          <p className="text-xl font-semibold">Miercoles 29</p>
          <p className="text-lg">12pm - 2pm</p>
          <p className="text-lg font-semibold">
          Entradas en vivo el miércoles 3/12 a las 10 a.m.</p>
        </div>

        <div className="border-t border-t-mandarin sm:flex justify-between p-6 ">
          <p className="text-xl font-semibold">viernes 03</p>
          <p className="text-lg">10am - 12pm</p>
          <p className="text-lg font-semibold">
          Entradas en vivo el miércoles 3/12 a las 10 a.m.</p>
        </div>
        
      </div>
    </div>
  );
}
